import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { paySubscription } from '../actions/subscriptionActions';
import axios from 'axios';

export const SubscriptionButton = ({subscriptionProduct, fee, user, student}) => {
	const dispatch = useDispatch()
	const stripe = useStripe();
    const elements = useElements();

	const [loading, setLoading] = useState(false)

	const {userInfo} = useSelector((state) => state.userSignin);

	const createSubscription = async (subscriptionProduct, subscriptionFee) => {
	
		const {data} = await axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/subscriptions/', {
			subscriptionProduct,
			subscriptionFee,
			student
		}, {
			headers: {
				Authorization: `Bearer ${userInfo?.token}`,
			}
		})
		return data
	}

	const [paymentError, setPaymentError] = useState(null)

	const subscribe = async() => {
		setLoading(true)
		const {subscription, clientSecret} = await createSubscription(subscriptionProduct, fee)

		const cardElement = elements.getElement(CardElement)

		const {error, paymentIntent} = await stripe.confirmCardPayment(clientSecret, {
			payment_method: {
				card: cardElement,
				billing_details: {
					name: user
				}
			}
		})

		if (paymentIntent?.status === 'succeeded') {
			dispatch(paySubscription(subscription?._id))
		} else {
			setLoading(false)
		}
		if (error) {
			setPaymentError(error.message)
			setLoading(false)
		} else {
			setPaymentError(null)
		}
	}

	return (
		<div className='d-grid gap-2 my-7'>
			<CardElement className='mb-4'/>
			<button disabled={loading || !fee} type='button' className='btn btn-primary' onClick={() => subscribe()}>
				{
					loading
					?
						<>Espere, por favor...</>
					:
						<>Suscribirse</>
				}
			</button>
			{
				paymentError &&
				<span className='text-danger'>{paymentError}</span>
			}
		</div>
	)
}